import React from 'react';
import PropTypes from 'prop-types';
import { Banner } from '@shopify/polaris';
import styleConstants from 'src/styles/constants';
import { BannerStatus } from './constants';

const BannerMessages = ({ message, status, title }) => {
  const messagesArray = Array.isArray(message) ? message : [message];
  return (
    <div className="error-state__container">
      <Banner status={status} title={title}>
        {messagesArray.map((m) => (
          <p key={m}>{m}</p>
        ))}
      </Banner>
      <style jsx>{`
        .error-state__container {
          margin-bottom: ${styleConstants.spacing.six};
        }
      `}</style>
    </div>
  );
};

BannerMessages.propTypes = {
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  status: PropTypes.oneOfType(Object.keys(BannerStatus)),
  title: PropTypes.string,
};

BannerMessages.defaultProps = {
  message: 'Error',
  status: 'critical',
  title: 'Error',
};

export default BannerMessages;
